// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2QRVB","savePackageButton":"ClientWallet_savePackageButton__3F6MV"};